export enum Type {
  Line = 'line',
  Circle = 'circle',
}

export type Size = 'small' | 'medium' | 'large' | 'xlarge';

export type ProgressBarProps = {
  strokeColor?: string;
  value: number;
  maxValue?: number;
  info?: (val: number, maxVal: number) => string | false | React.ReactNode;
  trailColor?: string;
  type?: Type;
  steps?: number;
  size?: Size;
  classNames?: string | string[];
  showText?: boolean;
  variant?: 'success' | 'warning' | 'info' | 'error' | 'filled';
  innerRadius?: number;
  rounded?: boolean;
};

export type Variant = 'success' | 'warning' | 'info' | 'error' | 'filled';

export type ProgressBarChildProps = {
  value: number;
  maxValue: number;
  info: (val: number, maxVal: number) => string | false | React.ReactNode;
  strokeColor?: string;
  trailColor: string;
  steps: number;
  classNames?: string | string[];
  getStatusIcon: (statusType: Variant | undefined) => React.ReactNode;
  size: Size;
  showText?: boolean;
  variant?: Variant;
  innerRadius?: number;
  rounded?: boolean;
};
